export default __webpack_public_path__ + "static/media/attach file.95411276.svg";